<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['school_mgt'] == 1">
      <div class="col-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-term size="sm" variant="primary"
                ><i class="mdi mdi-plus"></i> New Term</b-button
              >
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select
                      class="form-select form-select-sm mx-1"
                      v-model="perPage"
                      size="sm"
                      :options="Terms"
                    ></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
                <template #table-busy
                  ><div class="text-center text-primary my-2">
                    <b-spinner
                      class="align-middle"
                      type="grow"
                      small
                    ></b-spinner>
                    <strong>No Data Found</strong>
                  </div></template
                >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(active)="data">
                  <span v-if="data.item.active == 1">
                    <b-button type="button" class="btn-sm btn" variant="info">
                      <i class="mdi mdi-check"></i> Active
                    </b-button>
                  </span>
                  <span v-else>
                    <b-button
                      @click="makedefault(data.item.id, data.item.name)"
                      type="button"
                      class="btn-sm btn"
                      variant="secondary"
                      v-b-modal.password
                    >
                      <i class="mdi mdi-lock"></i> Set as Default</b-button
                    >
                  </span>
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <b-button
                      @click="edit(data.item.id, data.item.name)"
                      type="button"
                      class="btn-sm btn"
                      variant="primary"
                      v-b-modal.edit
                    >
                      <i class="mdi mdi-square-edit-outline"></i>
                    </b-button>
                    <b-button
                      @click="remove(data.item.id, data.item.name)"
                      type="button"
                      class="btn-sm btn"
                      variant="danger"
                      v-b-modal.delete
                    >
                      <i class="mdi mdi-trash-can"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="List"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="new-term"
        centered
        title="New School Term"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="addTerm">
          <div class="form-group mb-2">
            <label>Term Name</label>
            <input v-model="name" type="text" class="form-control" />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('new-term')"
              >Cancel</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="edit-term"
        centered
        title="Edit School Term"
        title-class="font-14"
        hide-footer
      >
        <form @submit.prevent="editTerm">
          <div class="form-group mb-2">
            <input v-model="id" type="hidden" />
            <label>Term Name</label>
            <input v-model="name" type="text" class="form-control" />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('edit-term')"
              >Cancel</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="change-term"
        centered
        title="Set as Default Term"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="makeDefualtTerm">
          <input v-model="id" type="hidden" />
          Are you sure you want to make <b>{{ name }}</b> the active School Term
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('change-term')"
              >Cancel</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-term"
        centered
        title="Delete School Term"
        title-class="font-12"
        hide-footer
      >
        <form @submit.prevent="removeTerm">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the School Term : <b>{{ name }}</b> ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-term')"
              >Cancel</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
            <center>
              <span class="text-primary h6"
                >You have no permission to view this Page.</span
              >
            </center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
// import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { schooltermMethods, schooltermComputed } from "@/state/helpers";

export default {
  page: {
    title: "School Terms",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "School Terms",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "School Terms", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Terms: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      userData: JSON.parse(localStorage.getItem("user")),
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "name", label: "Name", visible: true },
        { key: "active", label: "Active", visible: true },
        { key: "addedby", label: "Added by", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      id: "",
      name: "Term 1",
    };
  },
  computed: {
    ...schooltermComputed,
    List() {
      return this.schoolterms.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.schoolterms.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.schoolterms.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchSchoolTerms();
    this.TotalRows = this.schoolterms.length;
    this.isBusy = false;
  },
  methods: {
    ...schooltermMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show("edit-term");
    },
    makedefault(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show("change-term");
    },
    remove(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show("delete-term");
    },
    async addTerm() {
      let formData = new FormData();
      formData.append("name", this.name);
      let url = "/addterm";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSchoolTerms();
          this.$bvModal.hide("new-term");
          this.name = "";
          if (response.data.code == "200") {
            this.$swal({
              title: "Success",
              text: response.data.message,
              icon: "success",
            });
          } else {
            this.$swal({
              title: "Error",
              text: response.data.message,
              icon: "error",
            });
          }
        }
      });
    },
    async makeDefualtTerm() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/setactive";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSchoolTerms();
          this.$bvModal.hide("change-term");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async editTerm() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      let url = "/updateterm";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSchoolTerms();
          this.$bvModal.hide("edit-term");
          this.name = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async removeTerm() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removeterm";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSchoolTerms();
          this.$bvModal.hide("delete-term");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
  },
};
</script>
